export default __webpack_public_path__ + "static/media/freefrontend.4cc6ff5a.webp";